import { useFeatureFlag } from "@accurx/auth";
import { useDesktopVersion } from "@accurx/native";

const MIN_UNIFIED_COMPOSE_VERSION = "4.229.29664.0";

export const useCanUseToolbarUnifiedCompose = () => {
    const hasFeature = useFeatureFlag("AccurxDesktopEmbeddedCompose");
    const version = useDesktopVersion();

    return hasFeature && (version ?? "0") >= MIN_UNIFIED_COMPOSE_VERSION;
};
